import React from 'react'
import { DateTimeInput } from '@ztechapps/webui.date'
import { useUser } from '@ztechapps/common.hook'
import { formatDate, toDate } from '@ztechapps/common.utils'
import { InlineDisplayContent } from '@ztechapps/webui.input'
import { useCheckoutContext } from '../../index'

export const ShipmentDate = () => {
  const context = useCheckoutContext()
  const [shippingOptions, setShippingOptions] = context.shippingOptions

  const { user } = useUser()
  const timeZone = user?.timeZone ?? 'America/Chicago'
  const min = formatDate(toDate().startOf('day'), 'YYYY-MM-DD', timeZone)

  return (
    <InlineDisplayContent
      label="Shipping date"
      help="The date that you desired to ship this package. It cannot be the past date."
    >
      <DateTimeInput
        type="date"
        value={shippingOptions?.shipmentDate}
        onChange={(e) => {
          setShippingOptions({ shipmentDate: toDate(e, timeZone).toDate() })
        }}
        min={min}
      />
    </InlineDisplayContent>
  )
}
